module.exports = {"id":"dp2_2l7q1","category":"2.2","text":"Digital Sharing","instructions":"Are you responsible for selecting online content to be shared via the social media accounts of a company or organisation?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"questionType":"PickOne","random":false,"options":[{"id":"dp2_2l7q1-a1","text":"No","score":5.5},{"id":"dp2_2l7q1-a2","text":"Yes","score":7.5}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.2/l7q1.json
// module id = 1025
// module chunks = 41